import React from "react";
import PropTypes from "prop-types";
import logo from "../../assets/images/Neo_Logo_A.svg";

/**
 * ContentLoader
 * Loader que ocupa APENAS a área de conteúdo (não cobre sidebar/header).
 * Exibe a logo do app e os "pontinhos" animados de loading conforme preferência.
 */
const ContentLoader = ({ loading = true, message }) => {
    if (!loading) return null;

    return (
        <React.Fragment>
            <style>{`
                .neo-dots span {
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background-color: #556ee6; /* Primary color */
                    border-radius: 50%;
                    margin: 0 4px;
                    animation: neo-bounce 1.4s infinite ease-in-out both;
                }
                .neo-dots span:nth-child(1) { animation-delay: -0.32s; }
                .neo-dots span:nth-child(2) { animation-delay: -0.16s; }
                @keyframes neo-bounce {
                    0%, 80%, 100% { transform: scale(0); }
                    40% { transform: scale(1); }
                }
            `}</style>
            
            <div
                className="d-flex flex-column align-items-center justify-content-center w-100"
                style={{ minHeight: "30vh", opacity: 0.8 }}
            >
                <div className="text-center">
                    <img
                        src={logo}
                        alt="NeoApp Logo"
                        className="mb-3"
                        style={{ width: "50px", height: "auto" }}
                    />
                    
                    <div className="neo-dots d-flex justify-content-center align-items-center mb-2">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    
                    {message && (
                        <p className="text-muted mt-2 fw-medium text-uppercase font-size-12">
                            {message}
                        </p>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

ContentLoader.propTypes = {
    loading: PropTypes.bool,
    message: PropTypes.string
};

export default ContentLoader;
